import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import moment from "moment";
import { UI } from "../../../../services/ui.service";
import { SecEventsService } from "../sec-events.service";
import { Subscription } from "rxjs";
import { ConversionUtils } from "../../../../domain/conversion-utils";
import { RouteSecEventType } from "../../../../domain/route-sec-event-type";
import { SecEventCategory } from "../../../../domain/sec-event-category";
import { ShowRepository } from "../../../../domain/show-repository";
import { Show } from "../../../../domain/show";

@Component({
  selector: "evrideo-calendar-expandable-graphics-event",
  templateUrl: "./calendar-expandable-graphics-event.component.html",
  styleUrls: ["./calendar-expandable-graphics-event.component.scss"],
})
export class CalendarExpandableGraphicsEventComponent
  implements OnInit, OnDestroy
{
  @Input() graphicsData;

  @Input() show: Show;

  @Input() formatTime: (time: moment.Moment) => string;
  @Input() formatDuration: (duration: moment.Duration) => string;

  @Input() toggleSecEvent: (show: Show, eventId: string) => void;

  properties;

  textOverrides: string;

  onEventToggleSubscription: Subscription;
  timeChangeSubscription: Subscription;

  constructor(
    private ui: UI,
    private secEventsApi: SecEventsService,
    private changeDetectorRef: ChangeDetectorRef,
    private _showRepository: ShowRepository,
  ) {}

  ngOnInit(): void {
    this.properties = this.graphicsData.properties;
    this.textOverrides = this.concatTextOverrides();

    this.onEventToggleSubscription = this.secEventsApi.onEventToggle.subscribe(
      (data) => {
        if (
          data.showId === this.show.id &&
          data.id === this.graphicsData.properties.id &&
          data.offset === this.graphicsData.properties.offset
        ) {
          this.updateEventToggleUI();
        }
      },
    );

    this.timeChangeSubscription = this.secEventsApi.onTimeChange.subscribe(
      ({
        showId,
        identifier,
        originalOffset,
        newStartTime,
        newOffset,
        newEndTime,
        newDuration,
        eventType,
      }) => {
        if (
          eventType === SecEventCategory.Graphics &&
          showId === this.show.id &&
          identifier === this.graphicsData.properties.name &&
          originalOffset === this.graphicsData.properties.offset
        ) {
          this.graphicsData.properties.startTime = newStartTime;
          this.graphicsData.properties.offset = newOffset;
          this.graphicsData.properties.duration = newDuration;
          this.graphicsData.properties.endTime = newEndTime;
        }
      },
    );
  }

  concatTextOverrides() {
    if (
      !this.properties.textOverrides ||
      this.properties.textOverrides.length === 0
    ) {
      return "";
    }
    return this.properties.textOverrides
      .map((textOverride) => `${textOverride.Label}=${textOverride.Text}`)
      .join(", ");
  }

  ngOnDestroy(): void {
    this.timeChangeSubscription?.unsubscribe();
    this.onEventToggleSubscription?.unsubscribe();
  }

  updateEventToggleUI() {
    this.graphicsData.properties.enabled =
      !this.graphicsData.properties.enabled;
    this.changeDetectorRef.detectChanges();
  }

  async deleteEvent() {
    try {
      await this.secEventsApi.deleteEvent(
        SecEventCategory.Graphics,
        this.show.id,
        this.properties.name,
        this.properties.offset,
      );
    } catch (e) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "Error deleting event",
        message: e.message,
      });
    }
  }
}
